import React, { Fragment, useEffect, useState } from 'react'
import { Container, Accordion, Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Select from "react-select"
import Swal from 'sweetalert2'

import DatePicker from "../../components/calendar/Calendar"
import { getCalendarsByDate } from '../../actions/calendarsActions'
import { getMenus } from '../../actions/menusActions'
import { getRestaurant } from '../../actions/restaurantsActions'
import { addOrder } from '../../actions/ordersActions'
import { getProducts } from '../../actions/productsActions'
import Version from '../../version'

export default function TakeMenu() {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const {client} = useAuth()
    const { restaurantid } = useParams()
	const navigate = useNavigate()

    const dishesTypeResume = ['firstdishes', 'seconddishes']
    const dishesType = ['firstdishes', 'seconddishes', 'drinks', 'desserts']

    const {calendars, loading} = useSelector(state=>state.calendars)
	const {menus} = useSelector(state=>state.menus)
	const {restaurant} = useSelector(state=>state.restaurants)
	const {resultorder, productWrong} = useSelector(state=>state.orders)
	const {products} = useSelector(state=>state.products)


    //eslint-disable-next-line
    const [firstdishesTextIcons, setFirstdishesTextIcons] = useState([])
    //eslint-disable-next-line
    const [seconddishesTextIcons, setSeconddishesTextIcons] = useState([])
    //eslint-disable-next-line
    const [drinksTextIcons, setDrinksTextIcons] = useState([])
    //eslint-disable-next-line
    const [dessertsTextIcons, setDessertsTextIcons] = useState([])
    //eslint-disable-next-line
    const [complementsTextIcons, setComplementsTextIcons] = useState([])

    const [actualCalendar, setActualCalendar] = useState(false)

    const [selectDishesShow, setSelectDishesShow] = useState(false)
    const [orderAdd, setOrderAdd] = useState({
		userAdd: null,
		menuAdd: null,
		dateAdd: null,
		firstdishesAdd: null,
		seconddishesAdd: null,
		drinksAdd: null,
		dessertsAdd: null,
		complementsAdd: null,
		hourAdd: null
	})

	const [takeAway, setTakeAway] = useState(true)
	const [totalPrice, setTotalPrice] = useState(0)

	useEffect(() => {
		window.scrollTo({
            top:0,
            behavior: 'instant'
        })
		if(client){
			dispatch(getMenus())
			dispatch(getRestaurant(restaurantid))
			dispatch(getProducts())

			// Auto-cargar el menú de hoy (medianoche, igual que al hacer clic en el calendario)
			const today = new Date()
			today.setHours(0, 0, 0, 0)
			today.setMinutes(today.getMinutes() - today.getTimezoneOffset())
			const todayFormatted = today.toISOString().replace(/\.\d{3}Z$/, '+00:00')
			dispatch(getCalendarsByDate({ restaurant: restaurantid, date: todayFormatted }))
			setOrderAdd(prev => ({
				...prev,
				restaurantAdd: restaurantid,
				dateAdd: todayFormatted
			}))
		}
	//eslint-disable-next-line
	},[dispatch, t, client])

	const selectedDay = (val) => {
		let fechaABuscar = new Date(val)
		fechaABuscar.setMinutes(fechaABuscar.getMinutes() - fechaABuscar.getTimezoneOffset())
		let fechaABuscarFormateada = fechaABuscar.toISOString().replace(/\.\d{3}Z$/, '+00:00')

		dispatch(getCalendarsByDate({restaurant: restaurantid, date: fechaABuscarFormateada}))

        setOrderAdd({
			...orderAdd,
            restaurantAdd: restaurantid,
            dateAdd: fechaABuscarFormateada
        })
	}

	const selectedMenu = (menuselected, calendarId) => {

		let firstdishesArray = []
		let seconddishesArray = []
		let drinksArray = []
		let dessertsArray = []
		let complementsArray = []

		let calendarMenu = calendars?.find(calendar => calendar._id === calendarId)

		setActualCalendar(calendarMenu)

		calendarMenu?.firstdishes?.forEach(firstdish => {
			if(calendarMenu?.dishescomensals[firstdish._id] > 0){
				const supplementForRestaurant = firstdish.supplements?.find(supp => supp.restaurant.toString() === restaurantid)?.price || 0;
				let object
				if(firstdish.photo){
					object = {value: firstdish._id, label: <div><img src={firstdish.photo} alt={firstdish.name} height="30px" width="30px"/> {firstdish.name} {supplementForRestaurant > 0 ? '+ '+supplementForRestaurant+'€' : ''}</div>}
				}else{
					object = {value: firstdish._id, label: <div>{firstdish.name} {supplementForRestaurant > 0 ? '+ '+supplementForRestaurant+'€' : ''}</div>}
				}
				firstdishesArray.push(object)
			}

		})

		calendarMenu?.seconddishes?.forEach(seconddish => {
			if(calendarMenu?.dishescomensals[seconddish._id] > 0){
				const supplementForRestaurant = seconddish.supplements?.find(supp => supp.restaurant.toString() === restaurantid)?.price || 0;
				let object
				if(seconddish.photo){
					object = {value: seconddish._id, label: <div><img src={seconddish.photo} alt={seconddish.name} height="30px" width="30px"/> {seconddish.name} {supplementForRestaurant > 0 ? '+ '+supplementForRestaurant+'€' : ''}</div>}
				}else{
					object = {value: seconddish._id, label: <div>{seconddish.name} {supplementForRestaurant > 0 ? '+ '+supplementForRestaurant+'€' : ''}</div>}
				}
				seconddishesArray.push(object)
			}
		})

		products.forEach(product => {
			const supplementForRestaurant = product.supplements?.find(supp => supp.restaurant.toString() === restaurantid)?.price || 0;
			const priceForRestaurant = product.prices?.find(price => price.restaurant.toString() === restaurantid)?.price || 0;
			let object = {value: product._id,
				label:
					<div>
						{product.type === 'Drink'
						?
							restaurant?.drinkIncluded
								? `${product.name}${supplementForRestaurant > 0 ? ' + '+supplementForRestaurant+'€' : ''}`
								: `${product.name}${priceForRestaurant > 0 ? ' + '+priceForRestaurant+'€' : ''}`
						:
							`${product.name}${supplementForRestaurant > 0 ? ' + '+supplementForRestaurant+'€' : ''}`
						}
					</div>
			}
			let objectWithFoto = {value: product._id,
				label:
					<div>
						<img src={product.photo} alt={product.name} height="30px" width="30px"/>
						{product.type === 'Drink'
						?
							restaurant?.drinkIncluded
								? `${product.name}${supplementForRestaurant > 0 ? ' + '+supplementForRestaurant+'€' : ''}`
								: `${product.name}${priceForRestaurant > 0 ? ' + '+priceForRestaurant+'€' : ''}`
						:
							`${product.name}${supplementForRestaurant > 0 ? ' + '+supplementForRestaurant+'€' : ''}`
						}
					</div>
			}
			let objectComplementary = {value: product._id, label: <div>{product.name} {priceForRestaurant > 0 ? '+ '+priceForRestaurant+'€' : ''}</div>}
			let objectComplementaryWithFoto = {value: product._id, label: <div><img src={product.photo} alt={product.name} height="30px" width="30px"/> {product.name} {priceForRestaurant > 0 ? '+ '+priceForRestaurant+'€' : ''}</div>}
			if(product.type === 'Dish'){
				if(product.isComplement){
					if(product.photo){
						complementsArray.push(objectComplementaryWithFoto)
					}else{
						complementsArray.push(objectComplementary)
					}
				}
			}
			if(product.type === 'Drink'){
			    if(product.photo){
					drinksArray.push(objectWithFoto)
			    }else{
					drinksArray.push(object)
			    }
			    if(product.isComplement){
					if(product.photo){
						complementsArray.push(objectComplementaryWithFoto)
					}else{
						complementsArray.push(objectComplementary)
					}
			    }
			}
			if(product.type === 'Dessert'){
			    // if(product.photo){
				// 	dessertsArray.push(objectWithFoto)
			    // }else{
				// 	dessertsArray.push(object)
			    // }
			    if(product.isComplement){
					if(product.photo){
						complementsArray.push(objectComplementaryWithFoto)
					}else{
						complementsArray.push(objectComplementary)
					}
			    }
			}
		})

		// calendarMenu?.drinks?.forEach(drink => {
		// 	let object
		// 	if(drink.photo){
		// 		object = {value: drink._id, label: <div><img src={drink.photo} alt={drink.name} height="30px" width="30px"/> {drink.name}</div>}
		// 	}else{
		// 		object = {value: drink._id, label: <div>{drink.name}</div>}
		// 	}
		// 	drinksArray.push(object)
		// })

		calendarMenu?.desserts?.forEach(dessert => {
			if(calendarMenu?.dishescomensals[dessert._id] > 0){
				const supplementForRestaurant = dessert.supplements?.find(supp => supp.restaurant.toString() === restaurantid)?.price || 0;
				let object
				if(dessert.photo){
					object = {value: dessert._id, label: <div><img src={dessert.photo} alt={dessert.name} height="30px" width="30px"/> {dessert.name} {supplementForRestaurant > 0 ? '+ '+supplementForRestaurant+'€' : ''}</div>}
				}else{
					object = {value: dessert._id, label: <div>{dessert.name} {supplementForRestaurant > 0 ? '+ '+supplementForRestaurant+'€' : ''}</div>}
				}
				dessertsArray.push(object)
			}

		})

		// calendarMenu?.complements?.forEach(complement => {
		// 	let object
		// 	if(complement.photo){
		// 		object = {value: complement._id, label: <div><img src={complement.photo} alt={complement.name} height="30px" width="30px"/> {complement.name}</div>}
		// 	}else{
		// 		object = {value: complement._id, label: <div>{complement.name}</div>}
		// 	}
		// 	complementsArray.push(object)
		// })

		setFirstdishesTextIcons({options: firstdishesArray, selected: null})
		setSeconddishesTextIcons({options: seconddishesArray, selected: null})
		setDrinksTextIcons({options: drinksArray, selected: null})
		setDessertsTextIcons({options: dessertsArray, selected: null})
		setComplementsTextIcons({options: complementsArray, selected: null})

		setOrderAdd({
			...orderAdd,
			userAdd: client.id,
			menuAdd: menus?.find(menu => menu._id === menuselected),
			calendarAdd: calendarId
		})

		setTotalPrice(menus?.find(menu => menu._id === menuselected)?.price)

		setSelectDishesShow(true)
	}

	const selectDishesShowClose = () => {
		setSelectDishesShow(false)
	}

    const handleInputChange = ({target})=>{
        setOrderAdd({
            ...orderAdd,
            [target.name]: target.value
        })
    }

    const handleSelectChange = async(typeproduct, arrayProducts) => {
        setOrderAdd({
            ...orderAdd,
            [typeproduct]: arrayProducts
        })
		
		let previousTotalPrice = totalPrice

		if (typeproduct !== "complementsAdd") {
			const previousProductSelected = products?.find(p => p._id === orderAdd[typeproduct]?.value)
			const supplementForRestaurant = previousProductSelected?.supplements?.find(supp => supp.restaurant.toString() === restaurantid)?.price || 0;
			const priceForRestaurant = previousProductSelected?.prices?.find(price => price.restaurant.toString() === restaurantid)?.price || 0;
			let previousSupplement = true

			if(typeproduct === 'drinksAdd'){
				if(!restaurant?.drinkIncluded){
					previousSupplement = false
				}
			}
			if(previousSupplement){
				if (previousProductSelected && supplementForRestaurant > 0) {
					previousTotalPrice -= supplementForRestaurant
				}
			}else{
				if (previousProductSelected && priceForRestaurant > 0) {
					previousTotalPrice -= priceForRestaurant
				}
			}			


			const productSelected = products?.find(p => p._id === arrayProducts?.value)
			const supplementForRestaurantSelected = productSelected?.supplements?.find(supp => supp.restaurant.toString() === restaurantid)?.price || 0;
			const priceForRestaurantSelected = productSelected?.prices?.find(price => price.restaurant.toString() === restaurantid)?.price || 0;
			let productSupplement = 0
			let supplement = true
			if(typeproduct === 'drinksAdd'){
				if(!restaurant?.drinkIncluded){
					supplement = false
				}
			}
			if(supplement){
				if (supplementForRestaurantSelected > 0) {
					productSupplement =supplementForRestaurantSelected
				}
			}else{
				if (priceForRestaurantSelected > 0) {
					productSupplement = priceForRestaurantSelected
				}
			}

			setTotalPrice(parseFloat(previousTotalPrice) + parseFloat(productSupplement))
		} else {
			// Calculate previous price
			for await(const productAdded of orderAdd[typeproduct] || []) {
				const product = products?.find(p => p._id === productAdded.value)
				const priceProduct = product?.prices?.find(price => price.restaurant.toString() === restaurantid)?.price || 0;
				previousTotalPrice -= parseFloat(priceProduct)
			}

			// Calculate new price
			for await(const productAdded of arrayProducts) {
				const product = products?.find(p => p._id === productAdded.value)
				const priceProduct = product?.prices?.find(price => price.restaurant.toString() === restaurantid)?.price || 0;
				previousTotalPrice += parseFloat(priceProduct)
			}

			setTotalPrice(previousTotalPrice)
		}
    }

    const handleOrderAdd = (e) => {
        e.preventDefault()

		if(orderAdd?.firstdishesAdd && orderAdd?.seconddishesAdd){
			let complementsAddArr = orderAdd?.complementsAdd?.map(complement => {
				return complement.value
			})

			dispatch(addOrder({
				restaurantAdd: orderAdd?.restaurantAdd,
				userAdd: orderAdd?.userAdd,
				menuAdd: orderAdd?.menuAdd?._id,
				calendarAdd: orderAdd?.calendarAdd,
				dateAdd: orderAdd?.dateAdd,
				hourAdd: orderAdd?.hourAdd,
				firstdishAdd: orderAdd?.firstdishesAdd?.value,
				seconddishAdd: orderAdd?.seconddishesAdd?.value || null,
				drinkAdd: orderAdd?.drinksAdd?.value || null,
				dessertAdd: orderAdd?.dessertsAdd?.value || null,
				complementsAdd: complementsAddArr,
				takeAway: takeAway,
				price: totalPrice
			}))
		}else{
			Swal.fire({
				showConfirmButton: true,
				confirmButtonText: t('global.ok'),
				icon: 'warning',
				text: t('client.menus.needselectdish')
			})
		}
    }

	const takeAwayHandler = (e) => {
		setTakeAway(e.target.checked)
		if (e.target.checked) {
			setTotalPrice(parseFloat(totalPrice) + 1)
		} else {
			setTotalPrice(totalPrice - 1)
		}
	}

	useEffect(() => {
        if(resultorder){
            switch (resultorder) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('client.orders.orderadd')
                    }).then(() => {
						navigate('/client/pendingorders')
                    })
                    break;
				case 'maxcomensalswrong':
					Swal.fire({
						showConfirmButton: true,
						showDenyButton: false,
						confirmButtonText: t('global.great'),
						icon: 'warning',
						text: t('client.orders.productwrong')+' '+productWrong
					})
					break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultorder, navigate])

	return (
		<Container className='p-5'>
			<Row className="mb-3">
				<Col xs={2} className='p-0'>
					<Link className="p-0 my-3" to="/client/takerestaurant">
                        <img src="../../images/arrow-back.svg" alt="arrow-back" width={25}></img>
					</Link>
				</Col>
				<Col xs={8} className='text-center'>
					<h1 className='fs-18'>{t('client.takeorder.title')}</h1>
					{restaurant?.name && <p className='mb-0 fw-bold' style={{color: 'var(--naranja)'}}>{restaurant.name}</p>}
				</Col>
				<Col xs={2}></Col>
			</Row>
			<Row>
				<DatePicker
					getSelectedDay={selectedDay}
					labelFormat={"MMMM"}
					color={"#000000"}
					enableDaysBefore={0}
				/>
			</Row>
			<Row className="my-3">
				<Col>
					{loading ?
						<div className="d-flex justify-content-center">
							<Spinner animation="border" variant="primary" />
						</div>
					:
						calendars?.map((calendar, index) => (
							<Fragment key={index}>
								<Accordion key={index}>
									<Accordion.Item eventKey={index}> 
										<Accordion.Header>
											<Col className='d-flex justify-content-between'>
												<strong>{calendar?.menu?.name}</strong>
												<strong className='me-2'>{calendar?.menu?.price?.toFixed(2)}€</strong>
											</Col>
										</Accordion.Header>
										<Accordion.Body>
											<strong>{t('client.menus.hours')}:</strong> {calendar?.start_time+' - '+calendar?.end_time}
											{dishesTypeResume?.map((dishType, key) => (
												<Fragment key={key}>
													{//eslint-disable-next-line
													eval(`calendar?.${dishType}`)?.length > 0
														?
															<table>
																<thead>
																	<tr>
																		<th className='w-50'>{t(`client.menus.${dishType}`)}</th>
																	</tr>
																</thead>
																<tbody>
																	{//eslint-disable-next-line

																	eval(`calendar?.${dishType}`)?.map((product, index) => (
																		calendar?.dishescomensals[product._id] > 0
																			?
																				<tr key={index} className='text-start'>
																					<td>
																						- {product.name}
																					</td>
																					<td>
																						{product.allergens?.map((allergen, index2) => (
																							<img key={index2} src={`/images/allergens/${allergen}.svg`} alt={t(`client.products.${allergen}`)} height="30px" width="30px"/>
																						))}
																					</td>
																				</tr>
																			:
																				''
																	))}
																</tbody>
															</table>
														:
															<></>
													}
												</Fragment>
											))}
											<Row className="text-center my-3">
												<Col>
													<Button variant='primary' type="submit" className="btn-primary w-100 my-2" onClick={() => selectedMenu(calendar.menu._id, calendar._id)}>
														<>{t('client.menus.select')}</>
													</Button>
												</Col>
											</Row>
										</Accordion.Body>
									</Accordion.Item>
								</Accordion>
							</Fragment>
						))
					}
				</Col>
			</Row>
			<Row>
                <Col className='text-center mt-2'>
                    <Version />
                </Col>
            </Row>
			<Modal show={selectDishesShow} className="sd-modal sd-modal-order" aria-labelledby="contained-modal-title-vcenter" centered>
                <Form className="formulario" onSubmit={handleOrderAdd}>
					<Modal.Header className="modal-order-header border-0 p-0">
						<div className="modal-order-header-content w-100">
							<button type="button" className="modal-order-close" onClick={() => selectDishesShowClose()}>
								<i className='fa fa-times'></i>
							</button>
							{restaurant?.photo &&
								<div className="modal-order-restaurant-img" style={{ backgroundImage: `url('${restaurant.photo}')` }}></div>
							}
							<div className="modal-order-header-info">
								<span className="modal-order-label">{t('client.menus.createorder')}</span>
								<h2 className="modal-order-restaurant">{restaurant?.name}</h2>
								<h3 className="modal-order-menu">{orderAdd?.menuAdd?.name}</h3>
							</div>
						</div>
					</Modal.Header>
					<Modal.Body>
						<div className="px-4">
							<Row className="my-3">
								{dishesType.map((dishType, key) => (
									<Fragment key={key}>
										{`${dishType}TextIcons.options`
											?
												<Row className="my-2">
													<Col>
														<h3>{t(`client.menus.${dishType}One`)}</h3>
														<Select
															className="text-start"
															name={dishType}
															//eslint-disable-next-line
															options={eval(`${dishType}TextIcons.options`)}
															value={orderAdd?.dishType}
															isClearable
															onChange={(e) => handleSelectChange(`${dishType}Add`, e)}
														/>
													</Col>
												</Row>
											:
												<></>
										}
									</Fragment>
								))}
								<Row className="my-2">
									<Col>
										<h3>{t(`client.menus.complementsOne`)}</h3>
										<Select
											isMulti
											className="text-start"
											name='complementsAdd'
											//eslint-disable-next-line
											options={eval(`complementsTextIcons.options`)}
											value={orderAdd?.complementsAdd}
											onChange={(e) => handleSelectChange('complementsAdd', e)}
										/>
									</Col>
								</Row>
								<Row className="my-2">
									<Col>
										<h3>{t(`client.menus.hour`)}</h3>
										<Form.Control
											className="sd-input"
											type='time'
											name='hourAdd'
											min={actualCalendar?.start_time}
											max={actualCalendar?.end_time}
											value={orderAdd?.hourAdd || ''}
											onChange={handleInputChange}
											required
										/>
									</Col>
								</Row>
								<Row className="my-2">
									<Col className='d-flex'>
										<h2 className='me-3 text-uppercase'>{t(`client.menus.takeAway`)}</h2>
										{/* <Form.Check type="switch" onChange={takeAwayHandler} checked={takeAway}/> */}
									</Col>
								</Row>
							</Row>
						</div>
					</Modal.Body>
					<Modal.Footer className="d-block border-top pt-3 pb-3 px-4">
						<div className="d-flex justify-content-between align-items-center mb-2">
							<h2 className='fw-bold mb-0'>{t('client.menus.total')}:</h2>
							<h2 className="fw-bold mb-0" style={{color: 'var(--naranja)'}}>{totalPrice.toFixed(2)} €</h2>
						</div>
						<Button variant='primary' type="submit" className="btn-primary w-100 text-white">
							{t('client.menus.makeorder')}
						</Button>
					</Modal.Footer>
				</Form>
			</Modal>
		</Container>
	)
}